import SideMenu from "../../components/admin/SideMenu";
import YearlyAverageLists from "../../components/admin/lists/YearlyAverageLists";
import { useCurrentUser } from "../../hooks/useCurrentUser";

const AdminAverage = () => {
  const { currentUser } = useCurrentUser();

  return (
    <div className="main-admin">
      <div className="flex">
        <SideMenu />

        <div className="main-contents">
          {currentUser?.judge !== true ? (
            <>
              <h3>年別アベレージ</h3>

              <div className="permission-error">
                このページを表示する権限がありません。
              </div>
            </>
          ) : (
            <>
              <h3>年別アベレージ</h3>

              <YearlyAverageLists />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminAverage;
